import React from 'react';
import './undergroundInfrastructure.scss';
import communicationImage from './assets/ui_communication_2x.png';
import electricityImage from './assets/ui_electricity_2x.png';
import pipelinesImage from './assets/ui_pipelines_2x.jpg';
import waterSewerImage from './assets/ui_water_sewer_2x.jpg';
import {Helmet} from 'react-helmet';
/**
 * The UgiCommunicationsPage component.
 *
 * @constructor
 */
export class UndergroundInfrastructurePage extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    return (
      <div id="underground-infrastructure-page" className="system-page">
        <Helmet>
          <title>Underground Infrastructure - NEI</title>
          <meta name = "description" content ="The comforts we have come to enjoy in our daily lives are supported by an underground network of more than 7.1 million miles of buried infrastructure." />
        </Helmet>
        <div className="container-fluid">
          <div className="row row-alt">
            <div className="container">
              <div className="row">
                <div className="col">
                  <p>The comforts we have come to enjoy in our daily lives are supported by an underground network of more than 7.1 million miles of buried infrastructure.</p>
                  <ul>
                    <li>Power that turns the lights on when a switch is flipped</li>
                    <li>Pipes that carry our water and energy resources to heat and cool our homes</li>
                    <li>Wires that transmit phone, cable and data information that allow instant communication with the outside world</li>
                  </ul>
                  <p>Learn more about the facilities supporting our daily lives by clicking on the following areas below.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="row row-odd">
            <div className="container">
              <div className="row">
                <div className="col col-sm-6 col-md-6 col-lg-3">
                  <div className="thumbnail-link" onClick={ () => { this.props.history.push('/pipelines');} }>
                    <div className="overlay"></div>
                    <img src={pipelinesImage} alt="Pipelines Image" />
                    <div>
                      <a href="/pipelines">Pipelines</a>
                    </div>
                  </div>
                </div>
                <div className="col col-sm-6 col-md-6 col-lg-3">
                  <div className="thumbnail-link" onClick={ () => { this.props.history.push('/communications');} }>
                    <div className="overlay"></div>
                    <img src={communicationImage} alt="Communications Image" />
                    <div>
                      <a href="/communications">Communications</a>
                    </div>
                  </div>
                </div>
                <div className="col col-sm-6 col-md-6 col-lg-3">
                  <div className="thumbnail-link" onClick={ () => { this.props.history.push('/electric');} }>
                    <div className="overlay"></div>
                    <img src={electricityImage} alt="Electricity Image" />
                    <div>
                      <a href="/electric">Electric</a>
                    </div>
                  </div>
                </div>
                <div className="col col-sm-6 col-md-6 col-lg-3">
                  <div className="thumbnail-link" onClick={ () => { this.props.history.push('/water-sewer');} }>
                    <div className="overlay"></div>
                    <img src={waterSewerImage} alt="Water and Sewer Image" />
                    <div>
                      <a href="/water-sewer">Water &amp; Sewer</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="container">
              <div className="row">
                <div className="col">
                  <h2>
                    <a href="/resources" onClick={ e => { e.preventDefault(); this.props.history.push('/resources');} }>Resources</a>
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

UndergroundInfrastructurePage.propTypes = {};

export default UndergroundInfrastructurePage;



// WEBPACK FOOTER //
// ./src/components/pages/undergroundInfrastructure/UndergroundInfrastructurePage.js